import * as React from "react";
import { formatAmount, InvoiceItemType } from "@graffer-inc/cloud-gov-core";
import { matchType } from "../../../../../application/domain/base/base-type";
import dayjs from "../../../../../utils/date-utils";

export const PaymentItemLine: React.FC<{
  item: InvoiceItemType & {
    createdAt?: Date;
    operationIndex?: number;
  };
  isShowDate?: boolean;
}> = ({ item, isShowDate }) => {
  const isShowOpDate = item.createdAt && item.operationIndex === 0;
  return (
    <>
      <tr>
        {isShowDate && (
          <>
            {isShowOpDate && (
              <td
                style={{ borderTop: "1px solid #f2f2f2", borderBottom: "none" }}
              >
                <span className="is-small has-text-grey is-size-7">
                  {item.createdAt &&
                    dayjs(item?.createdAt).format("YYYY年MM月DD日 HH:mm")}
                </span>
              </td>
            )}
            {!isShowOpDate && <td style={{ borderBottom: "none" }} />}
          </>
        )}
        <td>
          <p>
            {matchType(item.type, {
              "": item.description,
              exceeding: "過入金",
              exceeding_adjuster: "過入金解消",
              deficiency: "入金不足",
              deficiency_adjuster: "入金不足解消",
            })}
          </p>
        </td>
        <td className="has-text-right">
          <p className="control">{formatAmount(item.amount)}円</p>
        </td>
      </tr>
    </>
  );
};
